<div class="header-container" [ngClass]="{ 'border-bottom': showExpand && !expanded }">
  <div class="header-text">
    <h3 (click)="emitExpand($event)" [ngClass]="{'pointer': showExpand}">{{text}}</h3>
  
    @if (info) {
      <mat-icon matTooltip="{{info}}" [matTooltip]="info">info_outlined</mat-icon>
    }
  </div>

  @if (showExpand) {
    <button matIconButton (click)="emitExpand($event)">
      @if (expanded) {
        <mat-icon>expand_less</mat-icon>
      }
      @if (!expanded) {
        <mat-icon>expand_more</mat-icon>
      }
    </button>
  }
</div>

